// id -> route name
// name -> title of the section
// ! In case if any of ids in the menu Array is modified, the modalMapper keys in (constants/mdm-v2/pageConstants.js) and (constants/mdm-v2/model-constants) should also be updated accordingly.
export const Menu = [{
  id: 'MDM',
  name: 'Data Manager',
  is_bulk_upload_v2: false,
}, {
  id: 'Role',
  name: 'Roles',
  permission: 'view_role',
  is_bulk_upload_v2: false,
}, {
  id: 'User',
  name: 'Users',
  permission: 'view_user',
  is_bulk_upload_v2: true,
}, {
  id: 'Depot',
  name: 'Depots',
  tlabel: 'MDM_DEPOT',
  permission: 'view_depot',
  is_bulk_upload_v2: true,
}, {
  id: 'extra_drop_off_charge',
  name: 'Drop Off Charge',
  permission: 'view_extra_drop_off_charge',
  is_bulk_upload_v2: true,
}, {
  id: 'mdmLocation',
  name: 'Locations',
  permission: 'view_mdmlocation',
  is_bulk_upload_v2: false,
}, {
  id: 'Consignee',
  name: 'Consignees',
  permission: 'view_consignee',
  is_bulk_upload_v2: true,
}, {
  id: 'Transporter',
  name: 'Transporters',
  tlabel: 'MDM_TRANSPORTER',
  permission: 'view_transporter',
  is_bulk_upload_v2: true,
}, {
  id: 'Material',
  name: 'Materials',
  permission: 'view_material',
  is_bulk_upload_v2: true,
}, {
  id: 'contract',
  name: 'Rate Matrix',
  permission: 'view_rate_matrix',
  is_bulk_upload_v2: true,
}, {
  id: 'contracttsd',
  name: 'Contract TSD Matrix',
  permission: 'view_contract',
  is_bulk_upload_v2: true,
}, {
  id: 'Bucc',
  name: 'Bu cc',
  permission: 'view_bucc',
  is_bulk_upload_v2: true,
}, {
  id: 'Detention',
  name: 'Detentions',
  permission: 'view_detention',
  is_bulk_upload_v2: true,
}, {
  id: 'Vehicle',
  name: 'Vehicles',
  permission: 'view_vehicle',
  is_bulk_upload_v2: true,
}, {
  id: 'transit_management',
  name: 'Transit Management',
  permission: 'view_transit_management',
  is_bulk_upload_v2: true,
},
{
  id: 'loading',
  name: 'Loading / Unloading',
  permission: 'view_loading',
  is_bulk_upload_v2: true,
},
{
  id: 'sla',
  name: 'SLA',
  permission: 'view_sla',
  is_bulk_upload_v2: true,
},
{
  id: 'exceptions',
  name: 'Rejections',
  permission: 'exceptions',
  is_bulk_upload_v2: false,
},
{
  id: 'base_fuel_rate',
  name: 'Base Fuel Rate',
  permission: 'view_bfr',
  is_bulk_upload_v2: true,
}, {
  id: 'VendorDepots',
  name: 'Vendor Depots',
  permission: 'view_vendor_depot',
  is_bulk_upload_v2: false,
}, {
  id: 'Port',
  name: 'Port',
  permission: 'view_port',
  is_bulk_upload_v2: false,
}, {
  id: 'CHA',
  name: 'CHA',
  permission: 'view_cha',
  is_bulk_upload_v2: false,
}, {
  id: 'Container',
  name: 'Container',
  permission: 'view_container',
  is_bulk_upload_v2: false,
}, {
  id: 'FreightForwarder',
  name: 'FreightForwarder',
  permission: 'view_freight_forwarder',
  is_bulk_upload_v2: false,
}, {
  id: 'VehicleDetail',
  name: 'Vehicle details',
  permission: 'view_mdm_blacklist_vehicle',
  is_bulk_upload_v2: true,
},
// {
//   id: 'blacklist_driver',
//   name: 'Blacklist Driver details',
//   permission: 'view_driver',
// },
{
  id: 'materialcategory',
  name: 'Material Categories',
  permission: 'view_materialcategory',
  is_bulk_upload_v2: true,
},
{
  id: 'dedicatedtruck',
  name: 'Dedicated trucks',
  permission: 'view_dedicatedtruck',
  is_bulk_upload_v2: true,
},
{
  id: 'purchase_order',
  name: 'Purchase order',
  permission: 'view_purchase_order',
  is_bulk_upload_v2: true,
},
// {
//   id: 'Carton',
//   name: 'Carton',
//   permission: 'view_carton',
//   is_bulk_upload_v2: false,
// },
// {
//   id: 'Carrier',
//   name: 'Carrier',
//   permission: 'view_carrier',
//   is_bulk_upload_v2: false,
// },
// {
//   id: 'ShipMethod',
//   name: 'ShipMethod',
//   permission: 'view_shipmethod',
//   is_bulk_upload_v2: false,
// },
{
  id: 'Driver',
  name: 'Driver Details',
  permission: 'view_driver',
  is_bulk_upload_v2: true,
},
// {
//   id: 'TransportationDB',
//   name: 'Transportation DB',
//   permission: 'view_transportationdb',
//   is_bulk_upload_v2: false,
// },
{
  id: 'BillDiscount',
  name: 'Bill Discount',
  permission: 'view_billdiscount',
  is_bulk_upload_v2: false,
},
{
  id: 'destination_charge',
  name: 'Destination Charge',
  permission: 'view_destination_charge',
  is_bulk_upload_v2: false,
},
{
  id: 'source_charge',
  name: 'Source Charge',
  permission: 'view_source_charge',
  is_bulk_upload_v2: true,
},
{
  id: 'package_master',
  name: 'Package master',
  permission: 'view_package_master',
  is_bulk_upload_v2: false,
},
{
  id: 'material_package_map',
  name: 'Material package mapping',
  permission: 'view_package_materials',
  is_bulk_upload_v2: false,
},
// {
//   id: 'Approval',
//   name: 'Approval',
//   permission: 'mdm_approval',
//   is_bulk_upload_v2: false,
// },
{
  id: 'route_master',
  name: 'Route',
  permission: 'view_route_master',
  is_bulk_upload_v2: false,
},
{
  id: 'activity_time',
  name: 'Activity Time SLA',
  permission: 'view_activity_time',
},
{
  id: 'transshipment',
  name: 'Transshipment',
  permission: 'view_transshipment',
},
{
  id: 'redirection',
  name: 'Redirection Master',
  permission: 'view_redirection',
  is_bulk_upload_v2: true,
},
{
  id: 'freight_zone',
  name: 'Freight Zone',
  permission: 'view_freight_zone',
  is_bulk_upload_v2: true,
},
{
  id: 'legal_entity',
  name: 'Legal Entity',
  permission: 'view_legal_entity',
  is_bulk_upload_v2: true,
},
];

// common action buttons
export const actionButtons = [
  {
    id: 'reject_list',
    name: 'Rejected List',
    show: false,
    class: 'header_sbtn',
    disabled: false,
    emitMethod: 'rejectDownload',
  },
  {
    id: 'upload',
    name: 'Upload',
    show: true,
    class: 'header_sbtn',
    disabled: false,
    dropdownList: [{
      id: 'bulk_upload',
      type: 'upload',
      name: 'Bulk Upload',
      uploadEmitMethod: 'bulkUpload',
    }],
  },
  {
    id: 'export',
    name: 'Export',
    show: true,
    class: 'header_sbtn',
    disabled: false,
    emitMethod: 'exportData',
  },
  {
    id: 'add',
    name: 'Add',
    show: true,
    class: 'header_pbtn',
    disabled: false,
    emitMethod: 'add',
  },
  {
    id: 'stop',
    name: 'Stop',
    show: false,
    class: 'header_pbtn',
    disabled: false,
    emitMethod: 'stop',
  },
];

// components which dont have search option
export const hideSearch = [];

// common search parameters
export const defaultSearchParameters = [
  {
    id: 1,
    name: 'Name',
    query: 'name',
  },
  {
    id: 2,
    name: 'Reference Id',
    query: 'ref_id',
  },
];
